import useQueryParams from '@common/src/hooks/useQueryParams';
import FlowProductsSidebar, {
  FlowProductsSidebarItem,
} from '@flows/src/components/flow-products/FlowProductsSidebar';
import AnvaProductCartWidget from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidget';
import AnvaFlowProductsSideBarBasketPriceSummary from '@flows/src/components/flow-products/AnvaFlowProductsSideBarBasketPriceSummary';
import AnvaFlowProductsSideBarBasketItems from '@flows/src/components/flow-products/sidebar/AnvaFlowProductsSideBarBasketItems';
import { useAnvaQuotesWithPolling } from '@flows/src/hooks/flow-products';

const AnvaFlowProductsSidebar = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;

  // needs to use with polling now because of the risk_object_name which is only returned on job finish
  const { data } = useAnvaQuotesWithPolling({
    sessionId,
    enabled: !!sessionId,
  });
  const isBasketPage = window.location.pathname.includes('basket');

  const sideBarItems: FlowProductsSidebarItem[] = [];

  // Add main items and sub-items to the sidebar
  if (data?.groupingResult) {
    for (const group of data.groupingResult.groups) {
      const { tag, index, risk_object_name } = group;

      const sidebarSubItem = {
        key: `${tag.id}-${index}`,
        label: risk_object_name || `${tag.name} ${index + 1}`,
        index,
      };
      const existingTagItem = sideBarItems.find(
        (item) => item.key === tag.id.toString(),
      );

      if (existingTagItem) {
        // Add sub-item if it doesn't exist
        const subItem = existingTagItem.subItems?.find(
          (subItem) => subItem.index === index,
        );

        if (!subItem) {
          existingTagItem.subItems = existingTagItem.subItems || [];
          existingTagItem.subItems.push(sidebarSubItem);
        }
        if (subItem && risk_object_name) {
          subItem.label = risk_object_name;
        }
      } else {
        // Create new main item
        sideBarItems.push({
          key: tag.id.toString(),
          label: tag.name,
          iconName: tag.icon_key,
          subItems: [sidebarSubItem],
        });
      }
    }
  }

  // Sort sub-items by index and filter out sub-items for tags with only one index/sub item
  const processedSideBarItems = sideBarItems.map((item) => {
    if (item.subItems) {
      // Sort sub-items by index
      const sortedSubItems = [...item.subItems].sort(
        (a, b) => a.index - b.index,
      );

      // If only one sub-item with index 0, remove sub-items
      if (sortedSubItems.length === 1 && sortedSubItems[0].index === 0) {
        return {
          ...item,
          subItems: undefined,
        };
      }

      return {
        ...item,
        subItems: sortedSubItems,
      };
    }
    return item;
  });

  return (
    <FlowProductsSidebar
      items={processedSideBarItems}
      isHidden={window.location.pathname.includes('selection-overview')}
      cartComponent={
        isBasketPage ? (
          <AnvaFlowProductsSideBarBasketPriceSummary />
        ) : (
          <AnvaProductCartWidget />
        )
      }
      basketItemsComponent={<AnvaFlowProductsSideBarBasketItems />}
    />
  );
};

export default AnvaFlowProductsSidebar;
